import { ClerkProvider, useAuth } from '@clerk/react';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { setTokenGetter } from '@/api/authInterceptor';
import { queryClient } from '@/api/queryClient';
import { Toaster } from '@/design-system/primitives/Toast/Toast';
import { useApplyTweaks } from '@/lib/tweaks';

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

function TweaksProvider({ children }: { children: ReactNode }) {
  useApplyTweaks();
  return <>{children}</>;
}

function AuthBridge({ children }: { children: ReactNode }) {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenGetter(() => getToken());
  }, [getToken]);

  return <>{children}</>;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ClerkProvider publishableKey={clerkPubKey}>
          <AuthBridge>
            <TweaksProvider>
              {children}
              <Toaster />
            </TweaksProvider>
          </AuthBridge>
        </ClerkProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
